import React from "react";
import "./GrampanchayatInfo.css";

const GrampanchayatInfo = () => {
  // Image files (local paths provided)
  const images = [
   
  ];

  return (
    <div className="gp-info-page">
      <header className="gp-header">
        <h1>मुख्यमंत्री समृद्ध पंचायतराज अभियान</h1>
        <p className="subtitle">ग्रामपंचायत: <strong>सायकी</strong> — ग्रामविहित माहिती</p>
      </header>

      {/* Hero / Photos */}
      <section className="photos-section">
        <h2>---</h2>
        <div className="photos-grid">
          {images.map((src, i) => (
            <figure key={i} className="photo">
              <img src={src} alt={`सायकी फोटो ${i + 1}`} />
              <figcaption>छायाचित्र {i + 1}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* Single page sections (scroll layout) */}
      <main className="content">
        <section id="population" className="card">
          <h2>लोकसंख्येची माहिती</h2>
          <ul>
            <li><strong>ग्रामपंचायत ची स्थापना :</strong> १ मे १९६६</li>
            <li><strong>एकूण लोकसंख्या (2011):</strong> 1998 (पुरुष: 984 | महिला: 1094)</li>
            <li><strong>एकूण कुटुंब संख्या :</strong> 285 (APL: 160 | BPL: 98)</li>
            <li><strong>वार्ड संख्या :</strong> 03 वॉर्ड</li>
            <li><strong>दलित वस्तींची संख्या :</strong> २</li>
          </ul>

          <h3>गावनिहाय लहान सारणी (शीर्षके)</h3>
          <table className="data-table">
            <thead>
              <tr>
                <th>गाव</th>
                <th>पुरुष</th>
                <th>महिला</th>
                <th>एकूण</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>सायकी</td>
                <td>301</td>
                <td>278</td>
                <td>589</td>
              </tr>
              <tr>
                <td>पाराडगाव</td>
                <td>121</td>
                <td>115</td>
                <td>236</td>
              </tr>
              <tr>
                <td>देहगाव</td>
                <td>128</td>
                <td>165</td>
                <td>293</td>
              </tr>
              <tr>
                <td>मासल्सुंड (उदा.)</td>
                <td>8</td>
                <td>8</td>
                <td>16</td>
              </tr>
              <tr className="total-row">
                <td><strong>एकूण</strong></td>
                <td><strong>560</strong></td>
                <td><strong>566</strong></td>
                <td><strong>1126</strong></td>
              </tr>
            </tbody>
          </table>
        </section>

        <section id="water" className="card">
          <h2>गावातील पाणीपुरवठा माहिती</h2>
          <ul>
            <li><strong>भौगोलिक क्षेत्रफळ :</strong> सायकी — ४५ हेक्टर (सूत्रानुसार)</li>
            <li><strong>सरकारी सार्वजनिक विहिरी :</strong> 4</li>
            <li><strong>नळ योजना विहिरीची संख्या :</strong> 2</li>
            <li><strong>नळ योजना भोअर वेलची संख्या :</strong> 2</li>
            <li><strong>नळ योजना पिण्याच्या पाण्याची टाकीची संख्या :</strong> 5</li>
          </ul>

          <h3>पाण्याचे साठा (जलधारणा क्षमता)</h3>
          <ol>
            <li>सायकी — 40,000 लिटर</li>
            <li>पाराडगाव — 10,000 लिटर</li>
            <li>देहगाव — 8,000 + 2,000 लिटर (विभागी टाक्या)</li>
          </ol>

          <p><strong>गावातील पिण्याच्या पाण्याची व्यवस्था:</strong> हातपंप 8 (हातपंप यंत्रणेची उपलब्धता)</p>
        </section>

        <section id="schools" className="card">
          <h2>प्राथमिक शाळा माहिती</h2>
          <p>शाळांची एकूण संख्या: <strong>3</strong></p>

          <div className="school-list">
            <article className="school">
              <h4>जिला परिषद प्राथमिक शाळा क्र. 1 (सायकी)</h4>
              <p>शौचालय संख्या: मुलगी 2, मुलासाठी 0 (सूचनांनुसार)</p>
            </article>

            <article className="school">
              <h4>जिल्हा परिषद प्राथमिक शाळा क्र. 2 (पाराडगाव)</h4>
              <p>शौचालय संख्या: मुलगी 1, मुलगांसाठी 0 (सूचनांनुसार)</p>
            </article>

            <article className="school">
              <h4>जिल्हा परिषद प्राथमिक शाळा क्र. 3 (देहगाव)</h4>
              <p>शौचालय संख्या: मुलगी 1, मुलांसाठी 0 (सूचनांनुसार)</p>
            </article>
          </div>

          <p className="note">शाळांबद्दलची संख्या आणि शौचालयांचे तपशील पुराव्याच्या प्रतिमांवरून घेतलेले आहेत. (स्रोत: उभ्या दिलेल्या इमेज)</p>
        </section>

        <section id="services" className="card">
          <h2>इतर माहिती व सेवा</h2>
          <ul>
            <li><strong>मुख्य पिके:</strong> कपास, सोयाबीन, धान, गहू व चना</li>
            <li><strong>ग्रामपंचायत सदस्य संख्या:</strong> 8 (महिला 4 सदस्य व पुरुष 4 सदस्य)</li>
            <li><strong>कर मागणी नमुना व प्रमाणे एकूण खातेदार:</strong> 111 (नमुना संख्या म्हणून सूचीतील आकडा)</li>
            <li><strong>खास पाणी पडी (टँक कनेक्शन) संख्या:</strong> 243 (चित्रातील आकडेवारीनुसार)</li>
          </ul>
        </section>

        <footer className="gp-footer">
          <p>पुन्हा खालील माहिती पीडीएफ मध्ये आहे.</p>
          <a className="pdf-download" href="/images/A.pdf" download>
            📄 PDF A डाउनलोड करा
          </a>
          <a className="pdf-download" style={{ marginLeft: "15px" }} href="/images/B.pdf" download>
            📄 PDF B डाउनलोड करा
          </a>
        </footer>
      </main>
    </div>
  );
};

export default GrampanchayatInfo;
